import { render, staticRenderFns } from "./newDongtai.vue?vue&type=template&id=8608e3f4&"
import script from "./newDongtai.vue?vue&type=script&lang=js&"
export * from "./newDongtai.vue?vue&type=script&lang=js&"
import style0 from "./newDongtai.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports